<template>
    <div class="container-fluid">
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" v-html="trans[locale].academic_year"></label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_year"
                             :options="selector_year_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="false"
                             :close-on-select="true"
                             :hide-selected="false"
                             :internal-search="true"
                             :searchable="false"
                             :allow-empty="false"
                             track-by="key"
                             label="name"
                             :disabled="loading"
                             :show-labels="false"
                >
                </multiselect>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].academic_section }}</label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_sections"
                             :options="selector_section_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="true"
                             :close-on-select="false"
                             :clear-on-select="false"
                             :hide-selected="true"
                             :searchable="false"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :disabled="loading"
                             :show-labels="false"
                >
                </multiselect>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].academic_level }}</label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_levels"
                             :options="selector_level_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="true"
                             :close-on-select="false"
                             :clear-on-select="false"
                             :hide-selected="false"
                             :searchable="false"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :disabled="loading"
                             :show-labels="false"
                             :limit="limit" :limitText="limitText"
                             group-values="libs"
                             group-label="language"
                             :group-select="true"
                >
                </multiselect>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].academic_class }}</label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_classes"
                             :options="selector_class_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="true"
                             :close-on-select="false"
                             :clear-on-select="false"
                             :hide-selected="false"
                             :searchable="false"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :disabled="loading"
                             :show-labels="false"
                             :limit="limit" :limitText="limitText"
                             group-values="libs"
                             group-label="language"
                             :group-select="true"
                >
                </multiselect>
            </div>
        </div>

        <div class="form-group row" v-if="selector_selected_year != null && !active_only">
            <label class="col-sm-3 col-form-label">{{ trans[locale].non_chinese_speaking }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_non_chinese_speaking_status"
                               value="ncs"
                               :disabled="loading"
                        ><span class="checkmark"></span>
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].language }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="radio"
                               name="language"
                               :disabled="loading"
                               v-model="selector_language_options"
                               value="all"
                        >
                        <span class="checkmark"></span> {{ trans[locale].language_all }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="radio"
                               name="language"
                               :disabled="loading"
                               v-model="selector_language_options"
                               value="chinese"
                        >
                        <span class="checkmark"></span> {{ trans[locale].language_chinese }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="radio"
                               name="language"
                               :disabled="loading"
                               v-model="selector_language_options"
                               value="non_chinese"
                        >
                        <span class="checkmark"></span> {{ trans[locale].language_non_chinese }}
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group row" v-if="selector_selected_year != null && typeof selector_selected_year.is_current_year != 'undefined' && selector_selected_year.is_current_year && !active_only">
            <label class="col-sm-3 col-form-label">{{ trans[locale].account_status }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_status"
                               value="active"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].status_active }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_status"
                               value="disable"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].status_disable }}
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group row" v-if="selector_selected_year != null && typeof selector_selected_year.is_current_year != 'undefined' && selector_selected_year.is_current_year">
            <label class="col-sm-3 col-form-label">{{ trans[locale].student_status }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_student_status"
                               value="in_attendance"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].student_status_in_attendance }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_student_status"
                               value="withdrawn"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].student_status_withdrawn }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_student_status"
                               value="graduated"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].student_status_graduated }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_student_status"
                               value="new_student"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].student_status_new_student }}
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group row" v-if="fetch_with_tuition_record != null && typeof fetch_with_tuition_record != 'undefined' && fetch_with_tuition_record">
            <label class="col-sm-3 col-form-label">{{ trans[locale].tuition_status }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_tuition_status"
                               value="have_tuition_record"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].have }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_tuition_status"
                               value="no_tuition_record"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].not_have }}
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].student }}</label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_users"
                             :options="selector_user_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="is_multiple"
                             :close-on-select="false"
                             :hide-selected="true"
                             :searchable="true"
                             :internal-search="true"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :loading="loading"
                             :disabled="loading"
                             :show-labels="false"
                             :show-no-results="false"
                             :limit="limit" :limitText="limitText"
                             group-values="libs"
                             group-label="language"
                             :group-select="true"
                >
                </multiselect>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../../store/store';
    import UserSelector from './UserSelector';
    export default {
        mixins: [ UserSelector ],
        name: 'SelectorClassStudent',
        store,
        data() {
            return Object.assign(
                {
                    selector_selected_year: null,
                    selector_selected_sections: null,
                    selector_selected_levels: null,
                    selector_selected_classes: null,
                    selector_language_options: 'all',
                    selector_selected_status: [ 'active' ],
                    selector_selected_student_status: [ 'in_attendance' ],
                    selector_selected_non_chinese_speaking_status: [],
                    selector_year_options: [],
                    selector_section_options: [],
                    selector_level_options: [],
                    selector_class_options: [],
                    selector_tuition_status: ['no_tuition_record'],
                }
            )
        },
        props: {
            limit_years : {
                type: Array,
                required: false
            },
            limit_sections : {
                type: Array,
                required: false
            },
            limit_levels : {
                type: Array,
                required: false
            },
            limit_classes : {
                type: Array,
                required: false
            },
            select_parent_by_student : {
                type: Boolean,
                required: false,
                default: false,
            },
            active_student : {
                type: Boolean,
                required: false,
                default: () => false,
            },
            fetch_with_freshman_class: {
                type: Boolean,
                required: false,
                default: false,
            },
            active_only: {
                type: Boolean,
                required: false,
                default: false,
            },
            fetch_with_tuition_record: {
                type: Boolean,
                required: false,
            },
            with_future_year: {
                type:Boolean,
                required: false,
                default: false,
            },
        },
        watch: {
            selector_selected_year: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_year]', 'gray');
                this.getSectionOptions();
            }, store.getters.debounceMS),
            selector_selected_sections: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_sections]', 'gray');
                this.getLevelOptions();
            }, store.getters.debounceMS),
            selector_selected_levels: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_levels]', 'gray');
                this.getClassOptions();
            }, store.getters.debounceMS),
            selector_selected_classes: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_classes]', 'gray');
                this.getUserOptions();
            }, store.getters.debounceMS),
            selector_language_options: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_language_options]', 'gray');
                this.getUserOptions();
            }, store.getters.debounceMS),
            selector_selected_status: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_status]', 'gray');
                this.getUserOptions();
            }, store.getters.debounceMS),
            selector_selected_student_status: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_student_status]', 'gray');
                this.getUserOptions();
            }, store.getters.debounceMS),
            selector_selected_non_chinese_speaking_status: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_non_chinese_speaking_status]', 'gray');
                this.getUserOptions();
            }, store.getters.debounceMS),
            selector_tuition_status: _.debounce(function(newVal) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_tuition_status]', 'gray');
                this.getUserOptions();
            }, store.getters.debounceMS),
        },
        methods: {
            initialSelector() {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [initialSelector]', 'gray');
                this.getYearOptions();
            },
            getYearOptions() {
                let self = this;
                let url = !self.with_future_year ? '/api/options/get-year?without_future=y' : '/api/options/get-year';
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getYearOptions] => ' + url, 'gray');
                let method = 'get';
                self.selector_selected_year = null;
                let successCallBack = (response) => {
                    if (!_.isUndefined(self.limit_years))
                    {
                        let limited_year_options = [];
                        _.forEach(response.data, (year_item) => {
                            if (self.limit_years.indexOf(year_item.key) != -1) {
                                limited_year_options.push(year_item);
                            }
                        });
                        self.selector_year_options = limited_year_options;
                    } else {
                        self.selector_year_options = response.data;
                    }
                    self.selector_selected_year = _.first(self.selector_year_options);
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getYearOptions]', 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(self.selector_year_options), 'success');
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getYearOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.getOptions(url, method, successCallBack, failedCallBack);
            },

            getSectionOptions() {
                let self = this;
                let url = '/api/options/get-section';
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getSectionOptions] => ' + url, 'gray');
                let method = 'get';
                self.selector_selected_sections = null;
                let successCallBack = (response) => {

                    if (!_.isUndefined(self.limit_sections))
                    {
                        let limited_section_options = [];
                        _.forEach(response.data, (section_item) => {
                            if (self.limit_sections.indexOf(section_item.key) != -1) {
                                limited_section_options.push(section_item);
                            }
                        });
                        self.selector_section_options = limited_section_options;
                    } else {
                        self.selector_section_options = response.data;
                    }

                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getSectionOptions]', 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    self.$nextTick(function() {
                        self.getLevelOptions();
                    });
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getSectionOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.getOptions(url, method, successCallBack, failedCallBack);
            },

            getLevelOptions() {
                let self = this;
                let url = '/api/options/get-level/';
                let sections = [];
                if (_.size(self.selector_section_options) > 0)
                {
                    if (_.isNull(self.selector_selected_sections) || _.size(self.selector_selected_sections) == 0)
                    {
                        _.forEach(self.selector_section_options, (option) => {
                            if (!_.isUndefined(option.key))
                            {
                                sections.push(option.key);
                            }
                        });
                    } else {
                        _.forEach(self.selector_selected_sections, (option) => {
                            if (!_.isUndefined(option.key))
                            {
                                sections.push(option.key);
                            }
                        });
                    }
                }

                url = url + _.join(sections, self.array_delimiter);
                url = url + '?extra=with_group&locale=' + this.locale;

                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getLevelOptions] => ' + url, 'gray');
                let method = 'get';
                let successCallBack = (response) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getLevelOptions]', 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(self.selector_selected_levels), 'gray');

                    if (!_.isUndefined(self.limit_levels))
                    {
                        let limited_level_options = [];
                        _.forEach(response.data, (level_item_group) => {
                            let limited_level_group_options = {};
                            limited_level_group_options['language'] = level_item_group['language'];

                            let limited_level_group = [];
                            _.forEach(level_item_group['libs'], (level_item) => {
                                if (_.indexOf(self.limit_levels, level_item.key) != -1)
                                {
                                    limited_level_group.push(level_item);
                                }
                            });
                            limited_level_group_options['libs'] = limited_level_group;
                            if (_.size(limited_level_group) > 0)
                            {
                                limited_level_options.push(limited_level_group_options);
                            }
                        });
                        self.selector_level_options = limited_level_options;
                    } else {
                        self.selector_level_options = response.data;
                    }
                    if (this.is_debug) this.debugMessage(JSON.stringify(self.selector_level_options), 'gray');

                    if (!_.isNull(self.selector_selected_levels))
                    {
                        let levels = [];
                        _.forEach(self.selector_selected_levels, (level) => {
                            _.forEach(self.selector_level_options, (level_group) => {
                                _.forEach(level_group.libs, (option) => {
                                    if (level.key == option.key)
                                    {
                                        levels.push(level);
                                    }
                                });
                            });
                        });
                        self.selector_selected_levels = self._cloneObject(levels);
                    }
                    self.$nextTick(function() {
                        if (_.size(self.selector_level_options) > 0) {
                            self.getClassOptions();
                        }
                    });
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getLevelOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.getOptions(url, method, successCallBack, failedCallBack);
            },
            getClassOptions () {
                let self = this;
                let url = '/api/options/get-class/level/' + self.selector_selected_year.key + '/';

                let levels = [];
                if (_.size(self.selector_level_options) > 0) {
                    if (_.isNull(self.selector_selected_levels) || _.size(self.selector_selected_levels) == 0) {
                        if (!_.isUndefined(self.limit_levels)) {

                            _.forEach(self.selector_level_options, (level_group) => {
                                _.forEach(level_group.libs, (level_item) => {
                                    if (_.indexOf(self.limit_levels, level_item.key) != -1)
                                    {
                                        levels.push(level_item.key);
                                    }
                                });
                            });

                        } else {
                            _.forEach(self.selector_level_options, (level_group) => {
                                _.forEach(level_group.libs, (option) => {
                                    if (!_.isUndefined(option.key)) {
                                        levels.push(option.key);
                                    }
                                });
                            });
                        }
                    } else {
                        _.forEach(self.selector_selected_levels, (option) => {
                            if (!_.isUndefined(option.key)) {
                                levels.push(option.key);
                            }
                        });
                    }
                }
                url = url + _.join(levels, self.array_delimiter);
                url = url + '?extra=with_group&locale=' + this.locale;
                if (this.fetch_with_freshman_class) {
                    url = url + '&type=all';
                }
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getClassOptions] => ' + url, 'gray');
                let method = 'get';
                let successCallBack = (response) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getClassOptions]', 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(self.selector_selected_classes), 'gray');

                    if (_.isUndefined(self.limit_classes))
                    {
                        self.selector_class_options = response.data;
                    }
                    else
                    {
                        let limited_class_options = [];
                        _.forEach(response.data, (class_item_group) => {
                            let limited_class_group_options = {};
                            limited_class_group_options['language'] = class_item_group['language'];

                            let limited_class_group = [];
                            _.forEach(class_item_group['libs'], (level_item) => {
                                if (_.indexOf(self.limit_levels, level_item.key) != -1)
                                {
                                    limited_class_group.push(level_item);
                                }
                            });
                            limited_class_group_options['libs'] = limited_class_group;
                            if (_.size(limited_class_group) > 0)
                            {
                                limited_class_options.push(limited_class_group_options);
                            }
                        });
                        self.selector_class_options = limited_class_options;
                    }
                    if (this.is_debug) this.debugMessage(JSON.stringify(self.selector_class_options), 'gray');

                    if (!_.isNull(self.selector_selected_classes)) {
                        let classes = [];
                        _.forEach(self.selector_selected_classes, (class_item) => {
                            _.forEach(self.selector_class_options, (class_group) => {
                                _.forEach(class_group.libs, (option) => {
                                    if (class_item.key == option.key) {
                                        classes.push(class_item);
                                    }
                                });
                            });
                        });
                        self.selector_selected_classes = self._cloneObject(classes);
                    }
                    self.$nextTick(function() {
                        if (_.size(self.selector_class_options) > 0) {
                            self.getUserOptions();
                        }
                    });
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getClassOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.getOptions(url, method, successCallBack, failedCallBack);
            },
            getUserOptions: _.debounce(function(){
                if (!_.isNull(self.selector_selected_year)) {
                    let self = this;
                    let ignored_users = [];
                    let selected_class_ids = [];

                    if (_.isNull(self.selector_selected_classes) || _.size(self.selector_selected_classes) == 0) {
                        if (_.isUndefined(self.limit_classes)) {
                            _.forEach(self.selector_class_options, (class_group) => {
                                _.forEach(class_group.libs, (item) => {
                                    selected_class_ids.push(item.key);
                                });
                            });
                        } else {
                            _.forEach(self.selector_class_options, (class_group) => {
                                _.forEach(class_group.libs, (class_item) => {
                                    if (_.indexOf(self.limit_classes, class_item.key) != -1)
                                    {
                                        selected_class_ids.push(class_item.key);
                                    }
                                });
                            });
                        }

                    } else {
                        _.forEach(self.selector_selected_classes, (item) => {
                            selected_class_ids.push(item.key);
                        });
                    }
                    let user_api = 'post';
                    let url = "/api/options/get-student/";
                    let post_params = {};
                    post_params['select_parent_by_student'] = this.select_parent_by_student;
                    if (user_api == 'post')
                    {
                        url = "/api/options/students/";
                        if (_.size(self.selector_class_options) == 0)
                        {
                            post_params['class'] = '_ALL_';
                        } else {
                            post_params['class'] = selected_class_ids;
                        }
                    } else {
                        if (_.size(self.selector_class_options) == 0)
                        {
                            url = url + '_ALL_/';
                        } else {
                            url = url + 'class/';
                            url = url + _.join(selected_class_ids, this.array_delimiter) + '/';
                        }
                    }

                    let selected_users_ids = [];
                    _.forEach(self.selector_selected_users, (item) => {
                        selected_users_ids.push(item.key);
                    });
                    if (user_api == 'post') {
                        post_params['selected_users'] = selected_users_ids;
                    } else {
                        url = url + _.join(selected_users_ids, this.array_delimiter);
                    }

                    let ignored_users_ids = [];
                    _.forEach(self.selector_ignored_users, (item) => {
                        ignored_users_ids.push(item.key);
                    });

                    let method = 'get';

                    let is_current_year = !_.isNull(self.selector_selected_year) &&
                        !_.isUndefined(self.selector_selected_year.is_current_year) &&
                        self.selector_selected_year.is_current_year;

                    if (user_api == 'post') {
                        post_params['extra'] = 'with_group';
                        post_params['locale'] = self.locale;
                        post_params['req_key'] = this.request_type;
                        post_params['ignored_users'] = ignored_users_ids;
                        post_params['year'] = self.selector_selected_year.key;
                        post_params['language'] = self.selector_language_options;
                        if (is_current_year && _.size(self.selector_selected_status) > 0) {
                            post_params['account_status'] = self.selector_selected_status;
                        }
                        if (is_current_year && _.size(self.selector_selected_student_status) > 0) {
                            post_params['student_status'] = self.selector_selected_student_status;
                        }
                        if (_.size(self.selector_selected_non_chinese_speaking_status) > 0) {
                            post_params['non_chinese_speaking_status'] = self.selector_selected_non_chinese_speaking_status;
                        }
                        if(!_.isNil(self.fetch_with_tuition_record) && self.fetch_with_tuition_record && _.size(self.selector_tuition_status) > 0) {
                            post_params['tuition_status'] = self.selector_tuition_status;
                        }
                        post_params['filter_state'] = 'standby';
                        // post_params['only_active'] = this.active_student;

                        method = 'post';

                    } else {
                        let req_param = {
                            extra: 'with_group',
                            locale: self.locale,
                            req_key: this.request_type,
                            ignored_users: ignored_users_ids,
                            year: self.selector_selected_year.key,
                            language: self.selector_language_options,
                            account_status: is_current_year && _.size(self.selector_selected_status) > 0 ? self.selector_selected_status : null,
                            student_status: is_current_year && _.size(self.selector_selected_student_status) > 0 ? self.selector_selected_student_status : null,
                            non_chinese_speaking_status: _.size(self.selector_selected_non_chinese_speaking_status) > 0 ? self.selector_selected_non_chinese_speaking_status : null,
                            filter_state: 'standby'
                        };
                        url = url + '?' + $.param(req_param);
                    }
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getUserOptions] => ' + url, 'gray');

                    let successCallBack = (response) => {
                        if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getUserOptions]', 'success');
                        if (_.isUndefined(response.data[0].libs)) {
                            if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                        } else {
                            if (this.is_debug) this.debugMessage(' Total Options: ' + _.size(response.data[0].libs), 'success');
                        }
                        self.selector_user_options = response.data;
                    };
                    let failedCallBack = (error) => {
                        if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getUserOptions]', 'error');
                        if (this.is_debug) this.debugMessage(error, 'error');
                        if (error.response.status == '422') {
                            this.$store.commit('setValidationError', error.toString())
                        } else {
                            this.$store.commit('setError', error.toString())
                        }
                    };

                    if (user_api == 'post')
                    {
                        this.postOptions(url, method, post_params, successCallBack, failedCallBack);
                    } else {
                        this.getOptions(url, method, successCallBack, failedCallBack);
                    }
                }
            }, store.getters.debounceMS),
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UserPicker/SelectorClassStudent.vue